import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function SignalIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <rect x="18.1429" y="10.2857" width="4.28571" height="17.1429" rx="2" fill="currentColor" />
      <rect x="9.57143" y="14.5714" width="4.28571" height="12.8571" rx="2" fill="currentColor" />
      <rect x="1" y="18.8571" width="4.28571" height="8.57143" rx="2" fill="currentColor" />
      <rect x="26.7143" y="6" width="4.28571" height="21.4286" rx="2" fill="currentColor" />
    </BaseIcon>
  );
}
